import { render, staticRenderFns } from "./RolesComponent.vue?vue&type=template&id=c0060514&scoped=true"
import script from "./RolesComponent.vue?vue&type=script&lang=js"
export * from "./RolesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0060514",
  null
  
)

export default component.exports